import FetchService from "../FetchService/CustomService";
import { getErrorMessage } from "../utils";

const BaseUrl = process.env.BASE_URL;

const CategoriesService = {
  /**
   * Fetch categories from the API
   * @returns {Promise} API response with categories data
   */
  async getCategories() {
    const url = BaseUrl + "/v2/metadata/v2/categories";
    const loaderConfig = { hasLoader: false };

    try {
      const res = await FetchService.getCall({
        url,
        loaderConfig
      });

      return res;
    } catch (error) {
      console.log("CategoriesService error:", error);
      return Promise.reject(getErrorMessage(error));
    }
  }
};

export default CategoriesService;
